import { ILeadPurchaseItem, OnboardingType } from 'models/lead.model'

export const getHasPaidUpsell = (
  purchases: ILeadPurchaseItem[] | null,
): boolean =>
  !!purchases?.find(
    ({ planOnboardingType }) => planOnboardingType === OnboardingType.UPSELL,
  )
